import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../TheCage";
import {CollapsePresentation} from "../runnerpresentations/maingame/win/CollapsePresentation";
import {NormalWin} from "../runnerpresentations/maingame/win/NormalWin";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {XBombPresentation} from "../runnerpresentations/maingame/win/XBombPresentation";
import {WinSummery} from "../runnerpresentations/maingame/win/WinSummery";
import {WildMiningPresentation} from "../runnerpresentations/maingame/win/WildMiningPresentation";
import {TheCageGameMode} from "../server/TheCageGameMode";
import {ScatterSymbol} from "../reels/ScatterSymbol";
import {gsap} from "gsap";
import {SanityCheckPresentation} from "../runnerpresentations/maingame/win/SanityCheckPresentation";
import {BrokeBankPresentation} from "../runnerpresentations/maingame/win/BrokeBankPresentation";
import {ReelUtils} from "../utils/ReelUtils";

export class TheCageWinPresentation implements FlowStatePresentation {
    private presentations:SimplePresentation[];


    constructor() {
        this.presentations = [
            new NormalWin(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.updateWin(controller), () => {return true}, "UpdateWin"),
            new XBombPresentation(),
            new WildMiningPresentation(),
           // new FreeSpinWon(),
            new CollapsePresentation(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.updateScatters(controller), () => {return true}, "updateScatters"),
            new WinSummery(),
            new BrokeBankPresentation(),
            new SanityCheckPresentation()
        ];
    }

    public start(flowStateController:FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "WinRunner ");
    }

    private updateWin(controller:SimplePresentationRunnerController) {
        //const useTotalWin = TheCage.model.gameData.accumulatedRoundWin != TheCage.model.gameData.totalSpinWinnings || TheCage.model.data.mode != TheCageGameMode.NORMAL;
        TheCage.keypadPlugin.setWin(TheCage.model.gameData.accumulatedRoundWin, true, TheCage.isWinBelowStake());
        controller.finish();
    }

    private updateScatters(controller:SimplePresentationRunnerController) {
        ReelUtils.resetScatter();
        if (TheCage.model.gameData.nextMode == TheCageGameMode.NORMAL || TheCage.model.gameData.nextMode == TheCageGameMode.FREESPIN) {
            ReelUtils.updateScatters();
        }
        controller.finish();
    }
}